import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { onBrandSubmit } from "../../controller/BrandController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Card, Form, InputGroup, Table } from 'react-bootstrap';
import { BrandEntity } from "../../dto/brand/BrandEntity";

const Brand = () => {
    const navigate = useNavigate();

    const [brand, setBrand] = useState<BrandEntity>({
      status: 'ACTIVE',
      medias: []
    });
  
    const usedRoles = brand.medias?.map(m => m.role).filter(r => r) ?? [];
    
    useEffect(() => {
      if (!AuthUtility.isUserLoggedIn()) {
          navigate("/login");
          window.location.reload();
      }
    }, [])
  
    const handleAddMedia = () => {
      if ((brand.medias?.length ?? 0) >= 3) return;
    
      setBrand(prev => ({
        ...prev,
        medias: [
          ...(prev.medias ?? []),
          {
            role: nextRole(),
            status: "ACTIVE",
            data: undefined,
            preview: undefined
          }
        ]
      }));
    };
  
    const brandSubmit = async () => {
      try {
          const formData = new FormData();
      
          // 1️⃣ Prepare category JSON (without files!)
          const brandPayload = {
            ...brand,
            medias: brand.medias?.map(m => ({
              role: m.role,
              status: m.status
            }))
          };
      
          // 2️⃣ Append category JSON
          formData.append(
            "brand",
            new Blob([JSON.stringify(brandPayload)], {
              type: "application/json"
            })
          );
      
          // 3️⃣ Append media files
          brand.medias?.forEach((m) => {
            if (m.data) {
              formData.append("medias", m.data);
            }
          });
      
          // 4️⃣ Send
          const response = await onBrandSubmit(formData);
          if (response.status === 0) {
              toast.success(response.msg);
          }

        } catch (e) {
          toast.error("Амжилтгүй");
        }
    }
  
    const nextRole = () => {
      const used = new Set(brand.medias?.map(m => m.role));
      if (!used.has("ICON")) return "ICON";
      if (!used.has("COVER")) return "COVER";
      return "BANNER";
    };
  
    return (
      <Container fluid>
          <div><Toaster position="top-right" reverseOrder={false}/></div>
          <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Брэнд</h3>
          <Form>
              <Row className="mb-3">
                  <Col sm={6} md={6} lg={6}>
                      <Form.Group controlId="categoryName">
                          <Form.Label>НЭР</Form.Label>
                          <Form.Control
                          size="sm"
                          type="text"
                          value={brand.name ?? ""}
                          onChange={(e) =>
                              setBrand({ ...brand, name: e.target.value })
                          }
                          required
                          />
                          <Form.Control.Feedback type="invalid">
                              Нэр оруулна уу.
                          </Form.Control.Feedback>
                      </Form.Group>
                  </Col>
              </Row>
              <Row className="mb-3">
                  <Col sm={6} md={6} lg={6}>
                      <Form.Group controlId="categoryOrder">
                          <Form.Label>ЭРЭМБЭ</Form.Label>
                          <Form.Control size="sm" type="text" 
                          onChange = {(event) => {
                              setBrand({
                                  ...brand,
                                  sortOrder: parseInt(event.target.value)
                              })
                          }} 
                          required />
                          <Form.Control.Feedback type="invalid">
                              Эрэмбэ оруулна уу.
                          </Form.Control.Feedback>
                      </Form.Group>
                  </Col>
              </Row>
  
              <Row className="mb-3">
                  <Col sm={6} md={6} lg={6}>
                      <Form.Group controlId="categoryOnWebTop">
                          <Form.Label>СТАТУС</Form.Label>
                          <Form.Select
                          size="sm"
                          value={brand.status}
                          onChange={(event) => {
                              setBrand({
                                  ...brand,
                                  status: event.target.value as any
                              })
                          }}
                          required>
                              <option value="ACTIVE">ACTIVE</option>
                              <option value="HIDDEN">HIDDEN</option>
                              <option value="DISABLED">DISABLED</option>
                          </Form.Select>
                      </Form.Group>
                  </Col>
              </Row>
              <Row className="mb-3">
                  <Col sm={9} md={9} lg={9}>
                          
                      {brand.medias?.map((m, i) => (
                      <Row key={i} className="border rounded p-2 mb-2">
                          <Col md={4}>
                          <Form.Select size="sm"
                              value={m.role}
                              onChange={(e) => {
                                  const temp = [...(brand.medias ?? [])];
                                  temp[i].role = e.target.value as any;
                                  setBrand({ ...brand, medias: temp });
                              }}
                              required
                          >
                              <option value="ICON" disabled={usedRoles.includes("ICON") && m.role !== "ICON"}>ICON</option>
                              <option value="COVER" disabled={usedRoles.includes("COVER") && m.role !== "COVER"}>COVER</option>
                              <option value="BANNER" disabled={usedRoles.includes("BANNER") && m.role !== "BANNER"}>BANNER</option>
                          </Form.Select>
                          </Col>
  
                          <Col md={4}>
                          <Form.Select size="sm"
                              value={m.status}
                              onChange={(e) => {
                                  const temp = [...(brand.medias ?? [])];
                                  temp[i].status = e.target.value as any;
                                  setBrand({ ...brand, medias: temp });
                              }}
                              required
                          >
                              <option value="ACTIVE">ACTIVE</option>
                              <option value="DRAFT">DRAFT</option>
                              <option value="DISABLED">DISABLED</option>
                              <option value="DELETED">DELETED</option>
                          </Form.Select>
                          </Col>
  
                          <Col md={3}>
                          <Form.Control
                              type="file"
                              accept="image/*"
                              size="sm"
                              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                  const file = e.target.files?.[0];
                                  const temp = [...(brand.medias ?? [])];
                                  temp[i].data = file;
                                  temp[i].preview = file ? URL.createObjectURL(file) : undefined;
                                  setBrand({ ...brand, medias: temp });
                              }}
                              required
                          />
                          </Col>
  
                          <Col md={1} className="d-flex align-items-center">
                          <Button
                              size="sm"
                              variant="danger"
                              onClick={() => {
                                  const temp = [...(brand.medias ?? [])];
                                  temp.splice(i, 1);
                                  setBrand({ ...brand, medias: temp });
                              }}
                          >
                              X
                          </Button>
                          </Col>
  
                          {m.preview && (
                          <Col md={12} className="pt-2">
                              <img src={m.preview} height={70} />
                          </Col>
                          )}
                      </Row>
                      ))}
  
                      <Button
                      size="sm"
                      variant="secondary"
                      disabled={(brand.medias?.length ?? 0) >= 3}
                      onClick={handleAddMedia}
                      >
                      + Зураг нэмэх
                      </Button>
                  </Col>
              </Row>
              <Row className="mb-3">
                  <Col sm={3} md={3} lg={3}>
                      <Button size="sm" type="button" onClick={brandSubmit}>
                          Хадгалах
                      </Button>
                  </Col>
              </Row>  
          </Form>
      </Container>
    )
}

export default Brand;